import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#e11d48', // Corporate primary red
      light: '#93c5fd', // Lighter version
      dark: '#be123c', // Hover red
      iconBlue: '#45beee', // Icon blue
    },
    corporatePrimary: {
      main: '#60a5fa', // Corporate primary
      dark: '#be123c', // Corporate primary hover
    },
    secondary: {
      main: '#f97316',
      light: '#fb923c',
      dark: '#ea580c',
    },
    background: {
      default: '#ffffff',
      paper: '#FFFFFF', // White background
    },
    text: {
      primary: '#212121',
      secondary: '#666666',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px', // Standard rounded corners
          textTransform: 'none', // No uppercase text
          fontWeight: 600, // Bold text
          fontSize: '14px', // Standard font size
          padding: '8px 16px', // Standard padding
          minHeight: '40px', // Minimum height for touch targets
        },
        contained: {
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
          color: '#ffffff',
          '&:hover': {
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
            transform: 'translateY(-1px)',
            color: '#ffffff',
          },
        },
        outlined: {
          borderWidth: '2px',
          '&:hover': {
            borderWidth: '2px',
          },
        },
      },
      defaultProps: {
        size: 'medium', // Standard size
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: 'var(--card-background)',
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundColor: 'var(--card-background)',
        },
      },
    },
  },
}); 